(function () {
  'use strict';

  angular
    .module('web2print.landing')
    .directive('homeDeliveryZipcodeValidator', homeDeliveryZipcodeValidator);

  homeDeliveryZipcodeValidator.$inject = ['$http'];

  function homeDeliveryZipcodeValidator ($http) {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/landing/homedelivery-zipcode-validator/homedelivery-zipcode-validator.directive.html',
      link: linkFunc,
      scope: {
        isValid: '=',
        zipCode: '='
      },
      controller: homeDeliveryZipcodeValidatorController,
      controllerAs: 'zipcodeValidator',
      bindToController: true
    };
    return directive;

    function linkFunc (scope, el, attr, ctrl) {
      el.addClass('zipcode-validator');
    }

    function homeDeliveryZipcodeValidatorController () {
      const vm = this;

      vm.isValid = false;
      vm.isValidating = false;
      vm.isSubmitted = false;

      vm.validateZipcode = validateZipcode;

      activate();

      //////////////////////

      function activate () {
        if (vm.zipCode) {
          validateZipcode(vm.zipCode);
        }
      }

      function validateZipcode (zipcode) {
        vm.isValidating = true;
        $http({
          method: 'GET',
          url: 'https://api2.postnord.com/rest/customer/v1/timeslot/timeslots?apikey=KEYHERE&serviceGroupCode=SE&serviceCode=17&toAddressPostalCode='+zipcode+'&toAddressCountryCode=SE'
        }).then(function successCallback (response) {
          const eveningSlot = _.find(response.data.data[0].timeslots, function (date) {
            return _.find(date.slot, function (slot) {
              return slot.from >= '17:00' && slot.to >= '17:00';
            });
          });
          vm.isValidating = false;
          vm.isSubmitted = true;
          vm.isValid = !!eveningSlot;
        }), function errorCallback (response) {
          console.log('Error' + response);
        };
      }
    }
  }

})();
